// extracted by mini-css-extract-plugin
export var accordion = "_ds-0";
export var chevron = "_ds-3";
export var closed = "_ds-2";
export var content = "_ds-4";
export var open = "_ds-1";
export var rotate = "_ds-5";